export default __webpack_public_path__ + "static/media/bannerSmall10.c619bc6f.png";